import React, { useEffect, useState } from 'react';
import SideNavLayout from '../../customsidenav/sidenavlayout';
import { useNavigate } from 'react-router-dom';
import CachedIcon from '@mui/icons-material/Cached';
import api from '../../api/api';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import ClearIcon from '@mui/icons-material/Clear';
import CustomMonthYearPicker from './Rdatepicker';

const Rpmreports = () => {
    const [date, setDate] = useState(""); // Date state
    const [monthlyDetails, setMonthlyDetails] = useState(null);
    const [eligible,setEligible]=useState(null)
    const [dataLoading, setDataLoading] = useState(false); // Loading state
    const [error, setError] = useState(null); // Error state
    const [isFiltered, setIsFiltered] = useState(false); // Check if filter is applied
    const navigate = useNavigate();
    const practiseid = window.getPracticeId();
    const [searchTerm, setSearchTerm] = useState("");  // State to hold the search term

    useEffect(() => {
        if (date && isFiltered) {
            if(eligible){
                fetchEligible(date)
            }else{
                  fetchMonthlyDetails(date);
            }
           // Fetch data when the date changes
        }
   
    }, [date, isFiltered]); // Dependency on date and isFiltered
 
    // Function to fetch monthly details based on the selected date
    const fetchMonthlyDetails = async (selectedDate) => {
        setDataLoading(true); // Start loading
        setError(null); // Reset error state
        const formattedDate = formatDate(selectedDate); // Format the selected date
 
        try {
            const response = await api.post(`/v1/${practiseid}/rpm-reports/monthly-details`, {
                "start_date": formattedDate, // Send the formatted date
            });
 
            if (response.status === 200) {
                setMonthlyDetails(response.data); // Store the response data
                console.log('Fetched Monthly Details:', response.data);
            } else {
                setMonthlyDetails([]); // Reset data if response is not successful
            }
        } catch (error) {
            setError(error); // Capture any error
            console.log('Error fetching monthly details:', error);
            setMonthlyDetails([]); // Reset data in case of error
        } finally {
            setDataLoading(false); // Stop loading
        }
    };
 
    const fetchEligible = async (selectedDate) => {
        setMonthlyDetails([])
      setDataLoading(true); // Start loading
      setError(null); // Reset error state
      const parsedDate = new Date(selectedDate);

      // Extract the year and month (note: months are 0-indexed in JavaScript)
      const year = parsedDate.getFullYear();  // Get the full year (e.g. 2023)
      const month = parsedDate.getMonth() + 1; 
      try {
          const response = await api.post(`/v1/${practiseid}/rpm-reports/eligible`,{
             "month": month,
             "year" : year
          });
 
          if (response.status === 200) {
            setEligible(response.data); // Store the response data
              console.log('Fetched Monthly Details:', response.data);
          } else {
            setEligible([]); // Reset data if response is not successful
          }
      } catch (error) {
          setError(error); // Capture any error
          console.log('Error fetching monthly details:', error);
          setEligible([]); // Reset data in case of error
      } finally {
          setDataLoading(false); // Stop loading
      }
  };
 
    // Helper function to format the date and set day to '01'
    const formatDate = (date) => {
        const selectedDate = new Date(date);
        const year = selectedDate.getFullYear();
        const month = (selectedDate.getMonth() + 1).toString().padStart(2, '0');
        return `${year}-${month}-01`; // Format as 'yyyy-mm-01'
    };
 
    // Set the date to the 1st of the month and disallow editing the day
 // Set the date to the 1st of the month and disallow editing the day
// const handleDateChange = (selectedDate) => {
//     if (selectedDate) {
//         const formattedDate = formatDate(selectedDate);  // Format the selected date
//         setDate(formattedDate); // Set the date state to formatted date (with day '01')
//         setIsFiltered(true); // Mark the filter as applied
//     }
// };

const handleSearch = (event) => {
    setSearchTerm(event.target.value);  // Update the search term
};

    const handleRefresh = () => {
        if (date) {
            setEligible(false)
            setMonthlyDetails([])
            fetchMonthlyDetails(date);
            // Fetch data based on the selected date
        }
    };

    const filteredMonthlyDetails = monthlyDetails?.filter((row) => {
        const searchLower = searchTerm.toLowerCase();
        return (
            row.patientid.toLowerCase().includes(searchLower) ||
            row.name.toLowerCase().includes(searchLower) ||
            row.email.toLowerCase().includes(searchLower)
        );
    });

    // Filter eligible based on search term (patientId)
    const filteredEligible = Object.keys(eligible || {}).filter((patientId) =>
        patientId.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="h-full">
            <SideNavLayout>
                <div className='w-full flex justify-end my-0'>
                <div onClick={() => navigate(-1)} className="  text-black  rounded">
                <ClearIcon className='text-gray-600'/>
                </div>
                </div>
                <div className="w-full flex justify-between items-center py-1 mt-0 ">
                    {/* Left Side: Back Button, Date Picker, and Refresh Button */}
                    <div className="flex space-x-4">
                  
                        <div
                             onClick={handleRefresh}
                            className="border-[1.5px] font-inter cursor-pointer flex border-gray-200 text-gray-600 px-2 text-[14px] items-center rounded"
                            disabled={!date} // Disable if no date is selected
                        >
                            <CachedIcon style={{width:"15px"}} className='mr-1' /> Refresh
                        </div>
 
                   
                     
                    </div>
               
                    {/* Right Side: Eligible Button */}
                    <div
                   
                    onClick={()=>{
                        setEligible(true)
                        fetchEligible(date)}}
                    className="bg-[#E179541A] font-inter text-[13px] cursor-pointer text-[#E17954] px-3 py-1 rounded">
                        Eligible
                    </div>
                </div>
                <div className="w-full flex justify-between items-center py-1 mt-0 ">
                <input
    placeholder="Search"
    type="text"
    value={searchTerm}  // Bind the input value to the searchTerm state
    onChange={handleSearch}  // Handle the input change and update the state
    className="w-[90%] border-[1.5px] border-gray-100 rounded py-[2px] px-2"
/>

                
                <CustomMonthYearPicker
        date={date} 
        setDate={setDate} 
        setIsFiltered={setIsFiltered} 
        formatDate={formatDate}
      />
                </div>
                <div className="w-full">
                    {/* Show message if no date is selected */}
                    {/* Table to display fetched data */}
                    {eligible ? (
                        <div >
        <div className="text-right py-2 px-2 text-green-600">
            <strong>Total Eligible Rows: {filteredEligible.length}</strong>
        </div>

             {/* Assuming the eligible call data is an array of dates */}
             <table className="min-w-full rounded-lg table-auto border-collapse border border-gray-300">
  {/* Table Header */}
  <thead >
    <tr className='bg-[#E1795454]'>
      <th className="border border-gray-300 px-4 py-2 text-left font-semibold text-center">Patient ID ( {filteredEligible.length}) </th>
      <th className="border border-gray-300 px-4 py-2 text-left font-semibold text-center">Eligible From</th>
      <th className="border border-gray-300 px-4 py-2 text-left font-semibold text-center">Eligible To</th>
    </tr>
  </thead>

  {/* Table Body */}
  <tbody >
  {dataLoading ? (
                                        <tr>
                                            <td colSpan="3" className="text-center px-4 py-2">
                                                <div className="text-center text-orange-500 mb-4">
                                                    <HourglassBottomIcon className="text-orange-500" /> Loading eligible data...
                                                </div>
                                            </td>
                                        </tr>
                                    ) : (
                                        filteredEligible.map((patientId) => (
                                            <tr key={patientId}>
                                                <td className="border border-gray-300 px-4 py-2 text-xs font-semibold">{patientId}</td>
                                                <td className="border border-gray-300 px-4 py-2 text-xs font-semibold">
                                                    {eligible[patientId] && new Date(eligible[patientId][0]).toLocaleString()}
                                                </td>
                                                <td className="border border-gray-300 px-4 py-2 text-xs font-semibold">
                                                    {eligible[patientId] && new Date(eligible[patientId][1]).toLocaleString()}
                                                </td>
                                            </tr>
                                        ))
                                    )}
  </tbody>
             </table>

                        </div>
                    ) : (
                        <div className=' rounded-lg' >
                    <table style={{borderTopLeftRadius:'10px',borderTopRightRadius:'10px'}} className="min-w-full rounded-[10px] table-auto ">
                        <thead className="bg-[#E1795454] font-inter text-[13px]">
                            <tr className="bg-[#E1795454]  ">
                                <th className="px-4 py-2 border ">#</th>
                                <th className="px-4 py-2 border">Patient ID</th>
                                <th className="px-4 py-2 border ">Name</th>
                                <th className="px-4 py-2 border ">Email</th>
                                <th className="px-4 py-2 border ">Enroll</th>
                                <th className="px-4 py-2 border ">Device Serial No.</th>
                                <th className="px-4 py-2 border ">{eligible?'Billing Count':'Count'}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* Show data if it's available */}
                            {filteredMonthlyDetails?.length > 0 ? (
                            filteredMonthlyDetails.map((row, index) => (
                                    <tr key={index} className="hover:bg-gray-100 text-[12px] font-inter">
                                        <td className="px-4 py-2 border">{index + 1}</td>
                                        <td className="px-4 py-2 border">{row.patientid}</td>
                                        <td className="px-4 py-2 border">{row.name}</td>
                                        <td className="px-4 py-2 border">{row.email}</td>
                                        <td className="px-1 py-2 border w-[100px]">{row.enroll_date}</td>
                                        <td className="px-4 py-2 border">{row.device_serial_number}</td>
                                        <td className="px-4 py-2 border">{!eligible?row.readingcount:row.billing_count}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" className="px-4 py-2 text-center">
                                        {dataLoading ? (
                                            <div className="text-center text-orange-500 mb-4">
                                                <HourglassBottomIcon className="text-orange-500" /> Please wait...
                                            </div>
                                        ) : (
                                          !date && !dataLoading && !isFiltered && (
                                            <div className="text-center text-red-500 mb-4">
                                                Please apply filter by selecting a date.
                                            </div>)
 
                                       )}
                                    </td>
                                </tr>
                            )}

                            
                        </tbody>
                    </table>
                    </div>
                )}
                </div>
            </SideNavLayout>
        </div>
    );
};
 
export default Rpmreports;